"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AresHazardPlacement = void 0;
var LogHelper_1 = require("../LogHelper");
var Phase_1 = require("../Phase");
var TileType_1 = require("../TileType");
var _AresHazardPlacement = (function () {
    function _AresHazardPlacement() {
    }
    _AresHazardPlacement.putHazardAt = function (space, tileType) {
        space.tile = { tileType: tileType, protectedHazard: false };
    };
    _AresHazardPlacement.randomlyPlaceHazard = function (game, tileType, direction) {
        var space = game.getSpaceByOffset(direction, tileType);
        this.putHazardAt(space, tileType);
        return space;
    };
    _AresHazardPlacement.makeSevere = function (game, from, to) {
        game.board.spaces
            .filter(function (s) { var _a; return ((_a = s.tile) === null || _a === void 0 ? void 0 : _a.tileType) === from; })
            .forEach(function (s) {
            if (s.tile !== undefined) {
                s.tile.tileType = to;
            }
        });
        game.log('${0} have upgraded to ${1}', function (b) { return b.string(TileType_1.TileType.toString(from)).string(TileType_1.TileType.toString(to)); });
    };
    _AresHazardPlacement.onTemperatureChange = function (game, aresData) {
        var _this = this;
        this.testConstraint(aresData.hazardData.severeErosionTemperature, game.getTemperature(), function () {
            _this.makeSevere(game, TileType_1.TileType.EROSION_MILD, TileType_1.TileType.EROSION_SEVERE);
        });
    };
    _AresHazardPlacement.onOceanPlaced = function (aresData, player) {
        this.testToPlaceErosionTiles(aresData, player);
        this.testToRemoveDustStorms(aresData, player);
    };
    _AresHazardPlacement.onOxygenChange = function (game, aresData) {
        var _this = this;
        this.testConstraint(aresData.hazardData.severeDustStormOxygen, game.getOxygenLevel(), function () {
            _this.makeSevere(game, TileType_1.TileType.DUST_STORM_MILD, TileType_1.TileType.DUST_STORM_SEVERE);
        });
    };
    _AresHazardPlacement.testToPlaceErosionTiles = function (aresData, player) {
        var _this = this;
        if (player.game.gameOptions.aresHazards === false) {
            return;
        }
        this.testConstraint(aresData.hazardData.erosionOceanCount, player.game.board.getOceansOnBoard(), function () {
            var type = TileType_1.TileType.EROSION_MILD;
            if (aresData.hazardData.severeErosionTemperature.available !== true) {
                type = TileType_1.TileType.EROSION_SEVERE;
            }
            var space1 = _this.randomlyPlaceHazard(player.game, type, 1);
            var space2 = _this.randomlyPlaceHazard(player.game, type, -1);
            [space1, space2].forEach(function (space) {
                LogHelper_1.LogHelper.logTilePlacement(player, space, type);
            });
        });
    };
    _AresHazardPlacement.testToRemoveDustStorms = function (aresData, player) {
        this.testConstraint(aresData.hazardData.removeDustStormsOceanCount, player.game.board.getOceansOnBoard(), function () {
            player.game.board.spaces.forEach(function (space) {
                var _a, _b;
                if (((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.DUST_STORM_MILD || ((_b = space.tile) === null || _b === void 0 ? void 0 : _b.tileType) === TileType_1.TileType.DUST_STORM_SEVERE) {
                    if (space.tile.protectedHazard !== true) {
                        space.tile = undefined;
                    }
                }
            });
            if (player.game.phase !== Phase_1.Phase.SOLAR) {
                player.increaseTerraformRating();
                player.game.log('${0}\'s TR increases 1 step for eliminating dust storms.', function (b) { return b.player(player); });
            }
        });
    };
    _AresHazardPlacement.testConstraint = function (constraint, testValue, cb) {
        if (!constraint.available) {
            return;
        }
        if (testValue >= constraint.threshold) {
            cb();
            constraint.available = false;
        }
    };
    return _AresHazardPlacement;
}());
exports._AresHazardPlacement = _AresHazardPlacement;
//# sourceMappingURL=AresHazards.js.map